export default "__VITE_ASSET__BwFGjfHI__"